import { __awaiter } from "tslib";
/** Waits for a condition to be true, then resolves the promise. If the condition is not true after maxAnimationFrames, the promise is rejected.
 * @param fn Function to check
 * @param maxAnimationFrames Max number of animation frames to wait
 *
 * @returns Promise<boolean>
 *
 * @example
 * ```
 * const result = await awaiterCycle(() => {
 *  return document.querySelector(".my-class") !== null;
 * }, 60); // 60 frames = aprox 1 second
 * ```
 * */
export const waitForCondition = (fn_1, ...args_1) => __awaiter(void 0, [fn_1, ...args_1], void 0, function* (fn, maxAnimationFrames = 60) {
    return new Promise((resolve, reject) => {
        function doCheckFn() {
            const result = fn();
            if (result) {
                resolve(true);
            }
            else {
                maxAnimationFrames--;
                if (maxAnimationFrames <= 0) {
                    reject(new Error("waitForCondition timeout"));
                }
                else {
                    globalThis.requestAnimationFrame(doCheckFn);
                }
            }
        }
        if (maxAnimationFrames > 600)
            throw new Error("maxAnimationFrames too high");
        doCheckFn();
    });
});
/** @deprecated Use waitForCondition instead */
export const awaiterCycle = waitForCondition;
/**
 * Returns a promise that resolves after a specified number of milliseconds.
 *
 * @param ms - The number of milliseconds to wait before resolving the promise.
 * @returns A promise that resolves after the specified delay.
 *
 * @example
 * ```typescript
 * await awaiter(1000); // Waits for 1 second
 * ```
 */
export function awaiter(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => globalThis.setTimeout(resolve, ms));
    });
}
